import React, { useReducer } from "react";
import { useDispatch } from "react-redux";
import { setMessageHandler } from "../../../reducers/selectedValues";
import { Box } from "@mui/material";
import { InputText } from "../../uiControls/inputText";
import { ComboBox } from "../../uiControls/comboBox";
import useHttpRequests from "../../../hooks/useHttpRequests";
import { MessageDisplay } from "../../common/messageDisplay";
import { SaveCancel } from "../../uiControls/saveCancel";
import CheckboxTreeControl from "../../uiControls/checkBoxTree";
import { StatusControl } from "../../uiControls/statusControl";
import * as utils from "../../common/utils";

const initialRoleIsValid = {
  name: "",
  description: "",
  defaultMenu: "",
  menuList: "",
};

export const RoleUpdate = (props) => {
  const {
    defaultMenu,
    menu,
    setUpdateOpen,
    roleEdit,
    setRoleEdit,
    roleAttributes,
  } = props;
  const messageDispatch = useDispatch();
  const { sendRequest: updateRole } = useHttpRequests();

  const [roleDetails, setRoleDetails] = useReducer(
    (state, updates) => ({ ...state, ...updates }),
    roleAttributes
  );

  const [isValid, setIsValid] = useReducer(
    (state, updates) => ({ ...state, ...updates }),
    initialRoleIsValid
  );

  const updateRoleDetailsValue = (_key, value) => {
    setRoleDetails({ [_key]: value });
    if (value) {
      updateErrorMessage([_key], "", "");
    }
  };

  const updateErrorMessage = (_key, header, errMsg) => {
    setIsValid({ [_key]: errMsg + header });
  };

  const onChangeHandler = (e, controlName) => {
    updateRoleDetailsValue(
      controlName,
      e.target.type === "checkbox" ? e.target.checked : e.target.value
    );
  };

  const defaultMenuChangeHandler = (e, newValue) => {
    if (newValue?.value) {
      updateRoleDetailsValue("defaultMenu", newValue.value);
    } else {
      updateRoleDetailsValue("defaultMenu", 0);
    }
  };

  const checkboxHandler = (checkedNodes) => {
    updateRoleDetailsValue("menuList", checkedNodes);
  };

  const cancelRoleHandler = () => {
    messageDispatch(setMessageHandler({ type: null, message: null }));
    setRoleEdit(false);
    setUpdateOpen(false);
  };

  const validateRoleDetails = () => {
    setIsValid(initialRoleIsValid);

    var errorSummary = "";

    if (!roleDetails.name) {
      updateErrorMessage("name", "Role Title", "Enter ");
      errorSummary += "Enter Role Title \n";
    } else if (!utils.isValidCharacters(roleDetails.name)) {
      updateErrorMessage("name", "Role Title", " has restricted characters");
      errorSummary += "Role Title has restricted characters \n";
    }

    if (!roleDetails.description) {
      updateErrorMessage("description", "Role Description", "Enter ");
      errorSummary += "Enter Role description \n";
    } else if (!utils.isValidCharacters(roleDetails.description)) {
      updateErrorMessage(
        "description",
        "Role Description",
        " has restricted characters"
      );
      errorSummary += "Role Description has restricted characters \n";
    }

    if (!roleDetails.defaultMenu) {
      updateErrorMessage("defaultMenu", "Default Menu", "Enter ");
      errorSummary += "Enter Default Menu \n";
    }

    if (roleDetails["menuList"]?.length <= 0) {
      updateErrorMessage("menuList", "Menu Options", "Select ");
      errorSummary += "Select Menu Options \n";
    }

    if (errorSummary !== "") {
      messageDispatch(
        setMessageHandler({ type: "error", message: errorSummary })
      );
    } else {
      const dataObj = roleDetails;
      delete dataObj["defaultMenuTitle"];

      const getUpdateRoleResponse = (resObj) => {
        if (
          !resObj ||
          !resObj["isSuccess"] ||
          (resObj["validationErrors"] !== undefined &&
            resObj["validationErrors"]?.length > 0)
        ) {
          messageDispatch(
            setMessageHandler({
              type: "error",
              message:
                (resObj["message"] ? resObj["message"] : "") +
                (resObj["validationErrors"]?.length > 0
                  ? "\n" + resObj["validationErrors"]?.join("\n")
                  : ""),
            })
          );
          return;
        }
        messageDispatch(
          setMessageHandler({
            type: "success",
            message: "Role updated successfully!",
          })
        );
        setTimeout(() => {
          cancelRoleHandler();
        }, 2000);
      };

      if (roleEdit) {
        updateRole(
          {
            url: "Roles/" + dataObj["roleKey"],
            method: "PUT",
            body: dataObj,
          },
          getUpdateRoleResponse
        );
      } else {
        delete dataObj["roleKey"];
        updateRole({ url: "Roles", body: dataObj }, getUpdateRoleResponse);
      }
    }
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          overflow: "hidden",
        }}
      >
        <MessageDisplay />
        <Box
          sx={{
            display: "flex",
            width: "100%",
          }}
        >
          <div
            style={{
              width: "50%",
              display: "flex",
              flexDirection: "column",
              gap: "20px",
            }}
          >
            <InputText
              type="text"
              label="Role Title"
              id={"roleDetails.name"}
              value={roleDetails.name}
              onChange={(e) => onChangeHandler(e, "name")}
              isRequired={true}
              isError={isValid["name"] !== ""}
              charLength={50}
            />

            <InputText
              type="text"
              label="Role Description"
              id={"roleDetails.description"}
              value={roleDetails.description}
              onChange={(e) => onChangeHandler(e, "description")}
              isRequired={false}
              isError={isValid["description"] !== ""}
              charLength={50}
            />

            <ComboBox
              id={"roleDetails.defaultMenu"}
              label="Default Menu"
              isError={isValid["defaultMenu"] !== ""}
              isRequired={true}
              isDisabled={false}
              selectedValue={roleDetails.defaultMenuTitle}
              list={defaultMenu}
              onChange={defaultMenuChangeHandler}
            />

            <StatusControl
              label="Active"
              isRequired={false}
              fieldName={"active"}
              active={roleDetails.active}
              updateStatusValue={updateRoleDetailsValue}
            />
            <SaveCancel
              cancelCall={() => cancelRoleHandler()}
              saveCall={() => validateRoleDetails()}
            />
          </div>
          <div
            style={{
              width: "50%",
              display: "flex",
              flexDirection: "column",
              gap: "20px",
            }}
          >
            <CheckboxTreeControl
              title="Select menu options:"
              isError={isValid["menuList"] !== ""}
              menu={menu}
              onChangeCall={checkboxHandler}
              selectedNodes={roleDetails.menuList}
            />
          </div>
        </Box>
      </Box>
    </>
  );
};
